<div bsModal #childModal="bs-modal" class="modal fade" [config]="{backdrop: 'static', keyboard: false}" tabindex="-1"
     role="dialog"
     aria-labelledby="mySmallModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header pt-0">
        <h3 class="modal-title m-auto">
          {{'ENTRY_TO_SYSTEM.AUTH.MODAL_TITLE' | translate}}
        </h3>
      </div>
      <div class="modal-body">
        <div class="row h-100 justify-content-center align-items-center px-3 text-center">
          {{'ENTRY_TO_SYSTEM.AUTH.MODAL_MESSAGE' | translate}}
        </div>
        <br>
      </div>
      <div class="modal-footer not-border justify-content-center align-items-center">
        <div class="row h-100">
          <a class="btn btn-kastor-fantasma m-1" (click)="logout()" href="#">
            {{'ENTRY_TO_SYSTEM.AUTH.LOGOUT' | translate}}
          </a>
          <button type="button" class="btn btn-kastor m-1" (click)="reauthenticate()">
            {{'ENTRY_TO_SYSTEM.AUTH.STILL_HERE' | translate}}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/controls/modal-session/modal-session.component.html